import React from 'react';
import { AppContext } from '../../App';

interface Props {
  children: React.ReactNode;
}

export default function IsStaff({ children }: Props) {
  const { isStaff } = React.useContext(AppContext);

  if (isStaff) return <>{children}</>;

  return null;
}
